import {useTranslation} from 'react-i18next';
import {Avatar, Button, cn} from '@chekinapp/ui';
import {GUEST_AVATAR_CLASS} from '../../constants';

type Props = {
  email: string;
  onChange?: () => void;
  disabled?: boolean;
};

const AuthIdentityChip = ({email, onChange, disabled}: Props) => {
  const {t} = useTranslation();

  return (
    <div className="flex items-center gap-2.5 rounded-xl bg-[var(--chekin-blue-surface-75)] px-3 py-[9px]">
      <Avatar
        size="sm"
        className="size-7 shrink-0"
        fallback={email.charAt(0)}
        fallbackClassName={cn(GUEST_AVATAR_CLASS, 'text-[12px] font-bold uppercase')}
        aria-hidden
      />
      <span className="min-w-0 flex-1 truncate text-[14px] text-[var(--chekin-color-brand-navy)]">
        {email}
      </span>
      {onChange && (
        <Button
          variant="link"
          onClick={onChange}
          disabled={disabled}
          className="h-auto shrink-0 p-0 text-[13px] font-semibold"
        >
          {t('auth.change_email')}
        </Button>
      )}
    </div>
  );
};

export {AuthIdentityChip};
